import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Heart } from "lucide-react";

export default function Cancel() {
    return (
        <div className="min-h-screen bg-ink-900 grain flex items-center justify-center px-6 py-16">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="max-w-xl w-full text-center"
                data-testid="cancel-page"
            >
                <Heart size={28} className="text-clay mx-auto mb-6" />
                <p className="label-eyebrow mb-4">No charge was made</p>
                <h1 className="heading-display text-5xl md:text-6xl mb-6">
                    Maybe <span className="italic text-clay">later.</span>
                </h1>
                <p className="text-lg text-cream-muted mb-10 font-light leading-relaxed">
                    Whenever you're ready, the guide will be here. Sleep is patient.
                    <br />
                    In the meantime — try Day 1 for free: pick a wake-up time and stick to it for 3 days.
                </p>
                <Link to="/" className="btn-primary" data-testid="back-home-button">
                    <ArrowLeft size={18} />
                    Back to the guide
                </Link>
            </motion.div>
        </div>
    );
}
